/* ============================================================
   FRAISE NOIRE — Formulaire de contact
   Sans serveur : compose un email pré-rempli dans l'application
   mail du visiteur. Rien n'est transmis à son insu.
   ============================================================ */
(() => {
  'use strict';
  const f = document.querySelector('[data-contact]');
  if (!f) return;
  f.addEventListener('submit', e => {
    e.preventDefault();
    if (!f.reportValidity()) return;
    const d = new FormData(f);
    const nom = (d.get('nom') || '').toString().trim();
    const mail = (d.get('email') || '').toString().trim();
    const sujet = (d.get('sujet') || 'Contact').toString();
    const msg = (d.get('message') || '').toString().trim();
    const corps = `${msg}\n\n—\n${nom}\n${mail}`;
    const T = window.FN_TRACK; T && T.custom && T.custom('contact_submit', { sujet });
    location.href = 'mailto:info@fraisenoire.com'
      + '?subject=' + encodeURIComponent('[Site] ' + sujet)
      + '&body=' + encodeURIComponent(corps);
  });
})();
